import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../../lib/net";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Reg_Allot extends React.Component {
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = { pgid: 11, tra: [] };
    this.state.seldate = new Date();
    this.state.avd = "01";
    this.state.rta = [];
    this.state.kro = {};
    this.state.aa = [];
    this.state.cols = {};
    //context.posrend = this;
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    //this.props.fetchWells()
    //  .then(res => this.setState({ wells: res.wells }) )
    this.rts();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      return css;
  }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }

  kund_open(row) {
      var self = this;
  }
  kund_edit(row) {
      var self = this;
      //alert(JSON.stringify(row.krr00));
        this.setState({edit: 1, kro: row});
  }
  fkn_close() {
    this.setState({edit: false });
    //this.props.history.push("cas");
    //this.login_srv(uid, pwd);
  }

  rts() {
    var self = this;
    var prm = {};
    prm.req = "pms.rt.rt_date";
    prm.rstyp = "M";
    prm.fdat = "20200915";
    prm.tdat = "20200915";
    //prm.avd = this.state.avd;

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        var o = {};
        //o.deps = ret.rco;
        //alert(JSON.stringify(o));
        self.setState({rta: ret.rco }, function () {
            self.syncCols("rtTable");
        });
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e) {
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }
  cssCols = function (cid) {
      var css = {};
      if(this.state.cols[cid]) css.width = this.state.cols[cid].toString() + "px";
      //if(cid == "c01") alert(JSON.stringify(this.state.cols[cid]));
      return css;
  }
  syncCols = function (tb) {

    if (!document.getElementById(tb)) return;

    var cols = {};
    var ix = document.getElementById(tb).rows.length - 1;
    var ic = document.getElementById(tb).rows[0].cells.length;
    var ci = 0;
    while(ci < ic) {
        var cxi = ci + 1;
        var col = "c" + cxi.toString().padStart(2, "0");
        cols[col] = document.getElementById(tb).rows[ix].cells[ci].clientWidth + 1;
        ci = ci + 1;
    }
    this.setState({cols: cols });
    //alert(JSON.stringify(this.state.cols));
    //this.forceUpdate();
  };

  render() {
    return (
    <div className="web-app">
    <div className="flex-row flex-space-between">
        <div className="flex-row flex">
        <button className="btn btn-hw-blue w150 ripple" onClick={() => this.syncCols("kidTable") } aria-label="System" >
            FUNKTIONER
        </button>
        </div>
        <div className="flex-row">
       </div>
        <div className="flex-row flex-end flex">
        <button className="btn btn-hw-blue w150 ripple" onClick={() => this.syncCols("kidTable") } aria-label="System" >
            UPPDATERA
        </button>
        </div>
    </div>
    <div className="divider_orange"></div>

    <div className="web-col">
        <table className="table table-bordered table-hover tb " style={{marginBottom: "0px"}}>
            <thead>
            <tr>
                <th style={ this.cssCols("c01" ) }>Typ</th>
                <th style={ this.cssCols("c02" ) }>Sort</th>
                <th style={ this.cssCols("c03" ) }>Antal</th>
                <th style={ this.cssCols("c04" ) }>Stängda</th>
                <th style={ this.cssCols("c05" ) }>Max</th>
                <th style={ this.cssCols("c06" ) }>Ledigt</th>
                <th style={ this.cssCols("c07" ) }>Status</th>
                <th style={ this.cssCols("c08" ) }></th>
                <th style={{width:"16px"}} ></th>
            </tr>
            </thead>
        </table>
       <div className="tb-cdi" style={ this.tb_style() }>
       <table id="rtTable" className="table table-bordered table-hover tb">
            <tbody>
            { this.state.rta.map((row, key) =>
            <tr key={key} id={ row.r1typ } onDoubleClick={() => this.kund_edit(row) }>
                <td>{ row.r1typ }</td>
                <td>{ row.r1sort }</td>
                <td>{ row.r1tillgr }</td>
                <td>{ row.r1closed }</td>
                <td>{ row.r1max }</td>
                <td>{ row.r1lediga }</td>
                <td>{ row.status }</td>
                <td style={{width:"40px",cursor:"pointer"}} onClick={() => this.kund_edit(row) }><i className="fa fa-cog text-danger"></i></td>
            </tr>
            )}
            <tr style={{visibility: "hidden"}}>
                <th>Typ</th>
                <th>Sort</th>
                <th>Antal</th>
                <th>Stängda</th>
                <th>Max</th>
                <th>Ledigt</th>
                <th>Status</th>
                <th></th>
            </tr>
            </tbody>
        </table>
        </div>
    </div>
   </div>
  );
    }
}
export default Reg_Allot;
